module.exports = __webpack_public_path__ + "static/media/get-started-nanny.155ed643.svg";